import React from 'react';
import PropTypes from 'prop-types';
import { buildSearchQuery, emboldenMatchingStrings } from '../helpers';
import { SuggestionsListWrapper } from '../styles';
import LinkHandler from '../../link-handler';

const SuggestionsList = ({ suggestions, section, searchTerm }) => (
  <SuggestionsListWrapper>
    {suggestions.map(({ query }, i) => {
      const searchQuery = buildSearchQuery({
        query,
        section,
      });
      return (
        <li key={i}>
          <LinkHandler
            link={{
              path: searchQuery,
              internal: true,
            }}
          >
            {emboldenMatchingStrings(query, searchTerm)}
          </LinkHandler>
        </li>
      );
    })}
  </SuggestionsListWrapper>
);

export default SuggestionsList;

SuggestionsList.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.object),
  section: PropTypes.string,
  searchTerm: PropTypes.string,
};
